import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Cny = function Cny(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CNY_svg__CNY_svg__clip0_9086_47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.204 10.726v-.848H8.705v-.804h1.499v-.847H9.077l2.39-4.118H9.925L8.027 7.527h-.043L6.08 4.109H4.533l2.395 4.118H5.807v.847H7.3v.804H5.807v.848H7.3V12h1.405v-1.274h1.499z",
    fill: "#505F79"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CNY_svg__CNY_svg__clip0_9086_47"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default Cny;